var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgOptimize28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75322 11.7508L10 11.0033L7.75322 10.2558L7 8L6.25322 10.2558L4 11.0033L6.25322 11.7508L7 14L7.75322 11.7508Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2H23V22H5V16.6586C2.66962 15.8349 1 13.6124 1 11C1 8.38756 2.66962 6.16508 5 5.34141V2ZM7 20V17C8.25163 17 9.41376 16.6168 10.3754 15.9612L13.2426 18.8284L14.6569 17.4142L11.8185 14.5758C12.5608 13.5772 13 12.3399 13 11C13 7.68629 10.3137 5 7 5V4H21V20H7ZM7 15C9.20914 15 11 13.2091 11 11C11 8.79086 9.20914 7 7 7C4.79086 7 3 8.79086 3 11C3 13.2091 4.79086 15 7 15Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 6H25V24H9V26H27V6Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOptimize28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;